// extracted by mini-css-extract-plugin
export default {"pageDescription":"ProjectsEpicsPage_pageDescription__Ha5UC"};